<template>
    <div class="spo-card rounded bordered p-1 my-2">
        <div class="text-h6">Envoi postal du dossard</div>
        <v-checkbox v-if="!is_changement_parcours" color="primary-dark" hide-details @change="onToggle"
            :label="'Recevoir mon dossard par courrier pour ' + envoi_postal.prix + '€'"
            v-model="envoi_postal.selected">
        </v-checkbox>
        <div class="text-body mt-2">
            Faites-vous envoyer votre dossard à l'adresse de votre choix avant l'événement.
        </div>
        <v-textarea v-if="envoi_postal.selected && !is_changement_parcours" class="mt-2"
            v-model="envoi_postal.adresse_postale" :placeholder="adresse_postale_placeholder" rows="4" auto-grow
            hide-details="auto" @update:model-value="$emit('changeEnvoiPostal')">
        </v-textarea>
    </div>
</template>

<script>
export default {
    props: ["item", "initial_commande_inscription"],
    data() {
        return {
            envoi_postal: {},
            adresse_postale_placeholder: "NOM PRENOM\nNUMÉRO ET RUE\nCODE POSTAL VILLE",
        };
    },
    computed: {
        is_changement_parcours() {
            return this.initial_commande_inscription;
        },
    },
    methods: {
        onToggle() {
            this.$emit('changeEnvoiPostal');
        },
    },
    mounted() {
        this.envoi_postal = this.item;
    },
}
</script>

<style lang="scss" scoped></style>
